(function () {
  const cart = window.RushTheme?.cart;
  if (!cart) return;
  const formatMoney = (cents, currency = "USD") =>
    new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency,
    }).format(Number(cents || 0) / 100);

  document.querySelectorAll("[data-configurator]").forEach((configurator) => {
    const options = [...configurator.querySelectorAll("[data-config-option]")];
    const layers = [...configurator.querySelectorAll("[data-config-layer]")];
    const total = configurator.querySelector("[data-config-total]");
    const submit = configurator.querySelector("[data-config-submit]");
    const share = configurator.querySelector("[data-config-share]");
    const message = configurator.querySelector("[data-config-message]");
    const groups = [...new Set(options.map((option) => option.dataset.group))];

    function selectOption(selected) {
      options.filter((option) => option.dataset.group === selected.dataset.group).forEach((option) => {
        const active = option === selected;
        option.setAttribute("aria-pressed", String(active));
        option.classList.toggle("is-selected", active);
      });

      const groupLayerIds = options.filter((option) => option.dataset.group === selected.dataset.group).map((option) => option.dataset.layer);
      layers.filter((layer) => groupLayerIds.includes(layer.dataset.configLayer)).forEach((layer) => {
        const active = layer.dataset.configLayer === selected.dataset.layer;
        layer.classList.toggle("is-visible", active);
        layer.setAttribute("aria-hidden", String(!active));
      });

      const price = options.filter((option) => option.getAttribute("aria-pressed") === "true").reduce(
        (sum, option) => sum + Number(option.dataset.price || 0),
        Number(total?.dataset.basePrice || 0),
      );
      if (total) total.textContent = formatMoney(price, window.Shopify?.currency?.active || "USD");
      const state = options.filter((option) => option.getAttribute("aria-pressed") === "true").map((option) => option.dataset.layer).join(",");
      const url = new URL(window.location.href);
      url.searchParams.set("build", state);
      window.history.replaceState({}, "", url);
    }

    const savedLayers = new URL(window.location.href).searchParams.get("build")?.split(",") || [];
    groups.forEach((group) => {
      const first = options.find((option) => option.dataset.group === group && savedLayers.includes(option.dataset.layer) && !option.disabled) || options.find((option) => option.dataset.group === group && !option.disabled);
      if (first) selectOption(first);
    });

    configurator.addEventListener("click", (event) => {
      const option = event.target.closest("[data-config-option]");
      if (option) selectOption(option);
    });

    submit?.addEventListener("click", async () => {
      const baseVariant = Number(submit.dataset.baseVariant);
      if (!baseVariant) return;
      const selected = options.filter((option) => option.getAttribute("aria-pressed") === "true");
      const properties = Object.fromEntries(selected.map((option) => [option.dataset.group, option.dataset.label]));
      const items = [{ id: baseVariant, quantity: 1, properties }];

      selected.forEach((option) => {
        const addonId = Number(option.dataset.addonId);
        if (addonId) items.push({ id: addonId, quantity: 1, properties: { "_Custom build component": option.dataset.group } });
      });

      submit.disabled = true;
      submit.setAttribute("aria-busy", "true");
      try {
        await cart.addItems(items);
      } catch (error) {
        cart.setStatus(error.message, true);
        cart.open();
      } finally {
        submit.disabled = false;
        submit.removeAttribute("aria-busy");
      }
    });

    share?.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        if (message) message.textContent = "Build link copied.";
      } catch (error) {
        if (message) message.textContent = "Copy the current URL to share this build.";
      }
    });
  });
})();
